module.exports = __webpack_public_path__ + "img/button_j.a0290bea.png";